<template>
  <table class="ts-w-full">
    <tbody>
      <tr class="ts-border-b ts-border-t">
        <td
          class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
        >
          {{ $t('task.priority') }}
        </td>
        <td class="ts-px-3 ts-w-3/12">
          <div class="ts-flex ts-items-center ts-space-x-2">
            <div
              class="ts-h-2 ts-w-2 ts-rounded-full"
              :class="[
                priorities[resource.priority_id]
                  ? priorities[resource.priority_id].color
                  : ''
              ]"
            ></div>
            <p class="ts-mb-0">
              {{
                priorities[resource.priority_id]
                  ? priorities[resource.priority_id].label
                  : ''
              }}
            </p>
          </div>
        </td>
        <td
          class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
        >
          {{ $t('task.status') }}
        </td>
        <td class="ts-px-3 ts-w-3/12">
          {{ resource.project_status }}
        </td>
      </tr>
      <tr class="ts-border-b ts-border-t">
        <td
          class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
        >
          {{ $t('task.estimatedStart') }}
        </td>
        <td class="ts-px-3 ts-w-3/12">
          {{
            resource.estimate_start_date ? resource.estimate_start_date : '-'
          }}
        </td>
        <td
          class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
        >
          {{ $t('task.owner') }}
        </td>
        <td class="ts-px-3 ts-w-3/12">
          {{ resource.owner_name }}
        </td>
      </tr>
      <tr class="ts-border-b ts-border-t">
        <td
          class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
        >
          {{ $t('task.estimatedEnd') }}
        </td>
        <td class="ts-px-3 ts-w-3/12">
          {{ resource.estimate_end_date ? resource.estimate_end_date : '-' }}
        </td>
        <td
          class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
        >
          {{ $t('task.project') }}
        </td>
        <td class="ts-px-3 ts-w-3/12">
          {{ resource.project_name ? resource.project_name : '-' }}
        </td>
      </tr>
      <tr class="ts-border-b ts-border-t">
        <td
          class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
        >
          {{ $t('task.actualStart') }}
        </td>
        <td class="ts-px-3 ts-w-3/12">
          {{ resource.actual_start_date ? resource.actual_start_date : '-' }}
        </td>
        <td
          class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
        >
          {{ $t('task.milestone') }}
        </td>
        <td class="ts-px-3 ts-w-3/12">
          {{ resource.milestone_name ? resource.milestone_name : '-' }}
        </td>
      </tr>
      <tr class="ts-border-b ts-border-t">
        <td
          class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
        >
          {{ $t('task.actualEnd') }}
        </td>
        <td class="ts-px-3 ts-w-3/12">
          {{ resource.actual_end_date ? resource.actual_end_date : '-' }}
        </td>
        <td
          class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
        >
          {{ $t('task.site') }}
        </td>
        <td class="ts-px-3 ts-w-3/12">
          {{ resource.site_name ? resource.site_name : '-' }}
        </td>
      </tr>
      <tr class="ts-border-b ts-border-t">
        <td
          class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
        >
          {{ $t('task.createdBy') }}
        </td>
        <td class="ts-px-3 ts-w-3/12">
          {{ resource.created_by_name }}
        </td>
        <td
          class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
        >
          {{ $t('task.client') }}
        </td>
        <td class="ts-px-3 ts-w-3/12">
          {{ resource.client_name ? resource.client_name : '-' }}
        </td>
      </tr>
      <tr class="ts-border-b ts-border-t">
        <td
          class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
        >
          {{ $t('task.createdDate') }}
        </td>
        <td class="ts-px-3 ts-w-3/12">
          <p class="ts-mb-0">{{ resource.created_at }}</p>
        </td>
        <td
          class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
        >
          {{ $t('task.mobileNumber') }}
        </td>
        <td class="ts-px-3 ts-w-3/12">
          <p class="ts-mb-0">
            {{
              resource.client_mobile_number
                ? resource.client_mobile_number
                : '-'
            }}
          </p>
        </td>
      </tr>
      <tr class="ts-border-b ts-border-t">
        <td
          class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
        >
          {{ $t('task.address') }}
        </td>
        <td class="ts-px-3 ts-w-3/12">
          {{ resource.client_address ? resource.client_address : '-' }}
        </td>
        <td
          class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
        >
          {{ $t('task.latLng') }}
        </td>
        <td class="ts-px-3 ts-w-3/12">
          <a
            target="_blank"
            :href="
              `https://maps.google.com/?q=${parseJson(resource.location_pin)}`
            "
          >
            {{ parseJson(resource.location_pin) }}
          </a>
        </td>
      </tr>
      <tr class="ts-border-b ts-border-t">
        <td
          class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
        >
          {{ $t('task.startName') }}
        </td>
        <td class="ts-px-3 ts-w-3/12">
          {{ resource.start_name }}
        </td>
        <td
          class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
        >
          {{ $t('task.endName') }}
        </td>
        <td class="ts-px-3 ts-w-3/12">
          {{ resource.end_name }}
        </td>
      </tr>
      <tr class="ts-border-b ts-border-t">
        <td
          class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
        >
          {{ $t('task.startPoint') }}
        </td>
        <td class="ts-px-3 ts-w-3/12">
          <a
            target="_blank"
            :href="
              `https://maps.google.com/?q=${parseJson(resource.start_location)}`
            "
          >
            {{ parseJson(resource.start_location) }}
          </a>
        </td>
        <td
          class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
        >
          {{ $t('task.endPoint') }}
        </td>
        <td class="ts-px-3 ts-w-3/12">
          <a
            target="_blank"
            :href="
              `https://maps.google.com/?q=${parseJson(resource.end_location)}`
            "
          >
            {{ parseJson(resource.end_location) }}
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: ['resource'],
  computed: {
    priorities() {
      return {
        1: {
          label: 'Low',
          color: 'ts-bg-gray-500'
        },
        2: {
          label: 'Normal',
          color: 'ts-bg-blue-500'
        },
        3: {
          label: 'Meduim',
          color: 'ts-bg-yellow-500'
        },
        4: {
          label: 'Hight',
          color: 'ts-bg-red-600'
        }
      }
    },
    parseJson: () => resource => {
      const parse = resource ? JSON.parse(resource) : undefined
      if (!parse) return ''

      return `${parse.lat},${parse.lng}`
    }
  }
}
</script>
